<template>
  <div>
    <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-paper-plane" aria-hidden="true"></i>
            New Message
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>
          <b-row>
            <b-col sm="12">
              <!-- App -->
              <b-form-group>
                <label for="sendTo">App</label>
                <b-input-group>
                <b-form-select v-model="selectedApp" :options="options"></b-form-select>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>

              <!-- Send to -->
              <b-form-group>
                <label for="sendTo">Send to</label>
                <b-input-group>
                <b-input-group-prepend>
                  <b-dropdown :text="sendType" variant="secondary">
                    <b-dropdown-item @click="sendType = 'token'">Token</b-dropdown-item>
                    <b-dropdown-item @click="sendType = 'refId'">Ref ID</b-dropdown-item>
                  </b-dropdown>
                </b-input-group-prepend>
                <b-form-input v-model="form.sendTo" :placeholder="sendTypePlaceHolder"></b-form-input>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>

              <!-- Tag -->
              <b-form-group>
                <label for="sendTo">Tag</label>
                <b-input-group>
                <vue-tags-input
                  class="tags"
                  v-model="form.tag"
                  :tags="tags"
                  placeholder="Enter Tag"
                  @tags-changed="newTags => tags = newTags"
                />
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>

              <!-- Topic -->
              <b-form-group>
                <label for="sendTo">Topic</label>
                <b-form-input v-model="form.topic" placeholder="Enter topic you need to send"></b-form-input>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
              </b-form-group>

              <!-- Message  -->
              <b-form-group>
                <label for="sendTo">Message</label>
                <b-form-textarea
                  v-model="form.message"
                  placeholder="Enter message you need to send"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="submitSend" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Send
          </b-button>
          <b-button disabled class="mr-2" type="submit" size="sm" variant="success">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button @click="setDefaults" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Reset
          </b-button>
        </div>
    </b-card>
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  data () {
    return {
      sendType: 'token',
      sendTypePlaceHolder: 'Enter tokens need to send',
      tagType: 'and',
      selectedApp: null,
      options: [{ value: null, text: 'select app to send' }],
      form: {},
      tagTest: '',
      tags: []
    };
  },
  watch: {
    sendType () {
      // for (const tag of this.tags) {
      //   console.log(tag.text);
      // }
      if ('token' === this.sendType) {
        this.sendTypePlaceHolder = 'Enter array of tokens need to send';
      } else if ('refId' === this.sendType) {
        this.sendTypePlaceHolder = 'Enter array of refIds need to send';
      } else if ('groupId' === this.sendType) {
        this.sendTypePlaceHolder = 'Enter groupId need to send';
      }
    }
  },
  methods: {
    setDefaults () {
      this.form = {};
      this.sendType = 'token';
      this.tagType = 'and';
      this.selectedApp = null;
    },
    getApiKey () {
      this.list = [];
      this.isBusy = true;
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/messaging/api-keys',
        {
          params: { page: this.currentPage }
        })
        .then(response => {
          const data = response.data ? response.data.data : null;
          if (!data) {
            throw new Error('Data not found');
          }
          for (const apiKey of data) {
            this.options.push({
              value: {
                apiKey: apiKey.apiKey,
                username: apiKey.username
              },
              text: apiKey.app
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitSend () {
      // check send type
      let form = {};
      if ('token' === this.sendType) {
        form = {
          apiKey: this.selectedApp.apiKey,
          username: this.selectedApp.username,
          deviceToken: JSON.parse(this.form.sendTo),
          tags: this.tags,
          notification: {
            title: this.form.topic,
            message: this.form.message,
            badge: 1,
            payload: {
              type: 'new',
              objectId: 1
            }
          }
        };
      } else if ('refId' === this.sendType) {
        form = {
          apiKey: this.selectedApp.apiKey,
          username: this.selectedApp.username,
          refId: JSON.parse(this.form.sendTo),
          tags: this.tags,
          notification: {
            title: this.form.topic,
            message: this.form.message,
            badge: 1,
            payload: {
              type: 'new',
              objectId: 1
            }
          }
        };
      }
      this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/messaging/notification/send', form)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    VueTagsInput
  },
  created () {
    this.getApiKey();
  }
};
</script>

<style scoped>
  .tags{
    width: 100%;
    max-width: none;
    font-size: 14px;
  }
</style>

<style>
  .ti-new-tag-input-wrapper{
    font-size: 14px !important;
  }
  li.ti-valid{
    background-color: #20a8d8 !important;
  }
  li.ti-deletion-mark{
    background-color: #f86c6b !important;
  }
</style>
